import request from '@/utils/request'
export function findExtates(estateName) {
    return request({
      url:`/api/APlus/find-extates?estateName=${estateName}`,
      method:'get'
    })
}

export function findBuilding(estateKeyId,estateName,buildingName) {
  return request({
    url:`/api/APlus/find-building?estateKeyId=${estateKeyId}&estateName=${estateName}&buildingName=${buildingName}`,
    method:'get'
  })
}

export function findVaildHouseSource(buildingKeyId,estateKeyId,houseNo) {
  return request({
    url:`/api/APlus/find-valid-house-source?buildingKeyId=${buildingKeyId}&estateKeyId=${estateKeyId}&houseNo=${houseNo}`,
    method:'get'
  })
}